<script setup>
const props = defineProps({
    tipo: {
        required: true,
        type: String,
        validator: (value) => {
            return ['preencher', 'sem-resultados', 'erro', 'sem-permissao'].includes(value);
        }
    },
    titulo: {
        type: String
    },
    subTitulo: {
        type: String
    },
    visible: {
        default: true,
        type: Boolean
    },
    showImage: {
        default: true,
        type: Boolean
    },
    size: {
        default: 'large',
        type: String,
        validator: (value) => {
            return ['large', 'small'].includes(value);
        }
    }
});

const containerStyle = {
    padding: props.size === 'large' ? '30px' : '20px',
    gap: props.size === 'large' ? '10px' : '0'
}

const imageStyle = {
    width: props.size === 'large' ? '200px' : '150px',
    margin: props.size === 'large' ? '20px 0' : '10px 0'
}

const BASE_PATH = '/images/';

const getImage = () => {
    switch (props.tipo.toLowerCase()) {
        case 'preencher':
            return BASE_PATH + 'preencha-os-campos.png';
        case 'sem-resultados':
            return BASE_PATH + 'nenhum-resultado.png';
        case 'erro':
            return BASE_PATH + 'erro.png';
        case 'sem-permissao':
            return BASE_PATH + 'sem-permissao.png';
        default:
            return '';
    }
}

const getAlt = () => {
    switch (props.tipo.toLowerCase()) {
        case 'preencher':
            return 'Lupa entre documentos';
        case 'sem-resultados':
            return 'Nenhum resultado encontrado';
        case 'erro':
            return 'Erro ao buscar processos';
        case 'sem-permissao':
            return 'Sem permissão para acessar';
    }
}

const getTitulo = () => {
    if (props.titulo && props.titulo !== '') return props.titulo;

    switch (props.tipo.toLowerCase()) {
        case 'preencher':
            return 'Preencha os campos acima';
        case 'sem-resultados':
            return 'Nenhum resultado encontrado';
        case 'erro':
            return 'Erro ao buscar resultados';
        case 'sem-permissao':
            return 'Sem permissão para acessar';
    }
}

const getSubTitulo = () => {
    if (props.subTitulo && props.subTitulo !== '') return props.subTitulo;

    switch (props.tipo.toLowerCase()) {
        case 'preencher':
            return 'Use os campos acima para encontrar resultados';
        case 'sem-resultados':
            return 'Ajuste os filtros ou revise as informações inseridas';
        case 'erro':
            return 'Tente novamente em instantes ou entre em contato com o suporte';
        case 'sem-permissao':
            return 'Você não possui permissão para acessar este conteúdo';
    }
}
</script>

<template>
    <div v-if="props.visible" class="search-result-message-container">
        <img :src="getImage()" :alt="getAlt()"/>

        <h3 :class="props.size === 'large' ? 'fs-3' : 'fs-5'">{{ getTitulo() }}</h3>

        <span>{{ getSubTitulo() }}</span>
    </div>
</template>

<style scoped>
.search-result-message-container {
    padding: v-bind(containerStyle.padding);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: v-bind(containerStyle.gap);
    text-align: center;
}

.search-result-message-container img {
    width: v-bind(imageStyle.width);
    margin: v-bind(imageStyle.margin);
}

.search-result-message-container span {
    word-break: break-word;
}
</style>
